/**
 * 执行除法的时候不保留小数位
 * @param dividend 被除数（Int 32）
 * @param divisor 除数（Int 32）
 * @returns 商（Int 32）
 */
export var forceDivide = function forceDivide(dividend, divisor) {
  return dividend / divisor >> 0;
};
//# sourceMappingURL=math.js.map